/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";

class Vendors extends Component {
  state = {
    data: {
      ArName: "",
      EnName: "",
      KuName: "",
      ArDescription: "",
      EnDescription: "",
      KuDescription: "",
      VendorTypeId: "",
      CompoundId: "",
      PhoneNo: "",
      Whatsapp: "",
      ArLocation: "",
      EnLocation: "",
      KuLocation: "",
      Latitude: "",
      Longitude: "",
      OpenFrom: "",
      OpenTo: "",
      IsActive: false,
      file: "",
    },

    contentHeader: "Vendors",
    addButtonLabel: "Add Vendor",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetVendors",
    singleItemUrl: "/api/data/GetVendor",
    addUrl: "/api/data/AddVendor",
    editUrl: "/api/data/EditVendor",
    deleteUrl: "/api/data/DeleteVendor",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Vendor",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Vendor",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,
    vendorTypesDropdown: [],
    compoundsDropdown: [],

    tableData: [],
  };

  componentDidMount() {
    this.getData();
    this.getVendorTypesDropdown();
    this.getCompoundsDropdown();
  }

  getVendorTypesDropdown() {
    post("/api/data/GetAllVendorTypes", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          vendorTypesDropdown: apiResponse.data.respData.data,
        });
      }
    );
  }

  getCompoundsDropdown() {
    post(
      "/api/data/GetAllCompoundsDropdown",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        compoundsDropdown: apiResponse.data.respData.data,
      });
    });
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["ArName"] = apiResponse.data.respData.data[0].AR_NAME;
      data["EnName"] = apiResponse.data.respData.data[0].EN_NAME;
      data["KuName"] = apiResponse.data.respData.data[0].KU_NAME;
      data["ArDescription"] = apiResponse.data.respData.data[0].AR_DESCRIPTION;
      data["EnDescription"] = apiResponse.data.respData.data[0].EN_DESCRIPTION;
      data["KuDescription"] = apiResponse.data.respData.data[0].KU_DESCRIPTION;
      data["VendorTypeId"] = apiResponse.data.respData.data[0].VENDOR_TYPE_ID;
      data["CompoundId"] = apiResponse.data.respData.data[0].COMPOUND_ID;
      data["PhoneNo"] = apiResponse.data.respData.data[0].PHONE_NO;
      data["Whatsapp"] = apiResponse.data.respData.data[0].WHATSAPP;
      data["ArLocation"] = apiResponse.data.respData.data[0].AR_LOCATION;
      data["EnLocation"] = apiResponse.data.respData.data[0].EN_LOCATION;
      data["KuLocation"] = apiResponse.data.respData.data[0].KU_LOCATION;
      data["Latitude"] = apiResponse.data.respData.data[0].LATITUDE;
      data["Longitude"] = apiResponse.data.respData.data[0].LONGITUDE;
      data["OpenFrom"] = apiResponse.data.respData.data[0].OPEN_FROM;
      data["OpenTo"] = apiResponse.data.respData.data[0].OPEN_TO;
      data["IsActive"] = apiResponse.data.respData.data[0].IS_ACTIVE;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    const data = new FormData();
    if (this.state.data.file) {
      data.append("File", this.state.data.file, this.state.data.file.name);
    }

    data.append("requestData", JSON.stringify(submitData));

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      data,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.arabicName"),
        field: "AR_NAME",
      },
      {
        id: 2,
        label: t("col.englishName"),
        field: "EN_NAME",
      },
      {
        id: 3,
        label: t("col.kurdishName"),
        field: "KU_NAME",
      },
      {
        id: 4,
        label: t("col.arabicDescription"),
        field: "AR_DESCRIPTION",
      },
      {
        id: 5,
        label: t("col.englishDescription"),
        field: "EN_DESCRIPTION",
      },
      {
        id: 6,
        label: t("col.kurdishDescription"),
        field: "KU_DESCRIPTION",
      },
      {
        id: 7,
        label: t("col.type"),
        field: "VENDOR_TYPE",
      },
      {
        id: 8,
        label: t("col.compound"),
        field: "COMPOUND_NAME",
      },
      {
        id: 9,
        label: t("col.phone"),
        field: "PHONE_NO",
      },
      {
        id: 10,
        label: t("col.whatsapp"),
        field: "WHATSAPP",
      },
      {
        id: 11,
        label: t("col.arabicLocation"),
        field: "AR_LOCATION",
      },
      {
        id: 12,
        label: t("col.englishLocation"),
        field: "EN_LOCATION",
      },
      {
        id: 13,
        label: t("col.kurdishLocation"),
        field: "KU_LOCATION",
      },
      {
        id: 14,
        label: t("col.latitude"),
        field: "LATITUDE",
      },
      {
        id: 15,
        label: t("col.longitude"),
        field: "LONGITUDE",
      },
      {
        id: 16,
        label: t("col.openFrom"),
        field: "OPEN_FROM",
      },
      {
        id: 17,
        label: t("col.openTo"),
        field: "OPEN_TO",
      },
      {
        id: 18,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 19,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 20,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB66"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB67"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.vendors")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB65"]) && (
              <Button
                label={t("pages.addVendor")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "ArName",
                label: t("col.arabicName"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnName",
                label: t("col.englishName"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuName",
                label: t("col.kurdishName"),
                disabled: false,
              },
              {
                type: "text",
                id: "ArDescription",
                label: t("col.arabicDescription"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnDescription",
                label: t("col.englishDescription"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuDescription",
                label: t("col.kurdishDescription"),
                disabled: false,
              },
              {
                type: "dropdown",
                id: "VendorTypeId",
                label: t("col.type"),
                options: this.state.vendorTypesDropdown,
                disabled: false,
              },
              {
                type: "dropdown",
                id: "CompoundId",
                label: t("col.compound"),
                options: this.state.compoundsDropdown,
                disabled: false,
              },
              {
                type: "text",
                id: "PhoneNo",
                label: t("col.phone"),
                disabled: false,
              },
              {
                type: "text",
                id: "Whatsapp",
                label: t("col.whatsapp"),
                disabled: false,
              },
              {
                type: "text",
                id: "ArLocation",
                label: t("col.arabicLocation"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnLocation",
                label: t("col.englishLocation"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuLocation",
                label: t("col.kurdishLocation"),
                disabled: false,
              },
              {
                type: "text",
                id: "Latitude",
                label: t("col.latitude"),
                disabled: false,
              },
              {
                type: "text",
                id: "Longitude",
                label: t("col.longitude"),
                disabled: false,
              },
              {
                type: "time",
                id: "OpenFrom",
                label: t("col.openFrom"),
                hourFormat: "24",
                disabled: false,
              },
              {
                type: "time",
                id: "OpenTo",
                label: t("col.openTo"),
                hourFormat: "24",
                disabled: false,
              },
              {
                type: "fileupload",
                id: "file",
                label: t("col.attachment"),
                disabled: false,
              },
              {
                type: "checkbox",
                id: "IsActive",
                label: t("col.isActive"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(Vendors);
